import type {
    MemberDataFirestoreRecord,
    PREFER_NOT_TO_USE_TITLE,
} from "@albertine/types";
import { PREFER_NOT_TO_USE_TITLE as PREFER_NOT_TO_USE } from "@albertine/types";
import type { Agent } from "../common/types/Agent";
import { joinWith } from "../common/utils/array.util";

export function formatMemberName(
    member: Pick<MemberDataFirestoreRecord, "title" | "firstName" | "lastName">,
): string {
    if (member.title && member.title !== PREFER_NOT_TO_USE) {
        return `${member.title} ${member.lastName}`;
    }
    return `${member.firstName} ${member.lastName}`;
}

export function memberNameBySurname(
    member: Pick<MemberDataFirestoreRecord, "firstName" | "lastName">,
): string {
    return `${member.lastName}, ${member.firstName}`;
}

export function agentNames(agents: Agent[]): string {
    const names = agents.map((it) => it.name);
    return joinWith(names, ", ", "and");
}

export function agentFirstnames(agents: Agent[]): string {
    const names = agents.map((it) => it.firstName);
    return names.join(", ");
}

export function joinDisplayName(
    firstName: string | undefined,
    lastName: string | undefined,
    title?: string,
): string {
    return [title, firstName, lastName]
        .map((part) => part?.trim())
        .filter((part) => !!part)
        .join(" ");
}
